import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import React from "react";
import BlockQuoteCitation from "./BlockQuoteCitation.esm.js";
import BlockQuoteContent from "./BlockQuoteContent.esm.js";
const BlockQuote = ({
  children
}) => {
  const contentElement = React.Children.toArray(children).find((child) => React.isValidElement(child) && child.type === BlockQuoteContent);
  const citationElement = React.Children.toArray(children).find((child) => React.isValidElement(child) && child.type === BlockQuoteCitation);
  return /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    margin: 0
  }, children: /* @__PURE__ */ jsxs("figure", { children: [
    /* @__PURE__ */ jsx(Box, { asChild: true, css: {
      margin: 0
    }, children: /* @__PURE__ */ jsx("blockquote", { children: contentElement }) }),
    citationElement && /* @__PURE__ */ jsx("figcaption", { children: citationElement })
  ] }) });
};
BlockQuote.Content = BlockQuoteContent;
BlockQuote.Citation = BlockQuoteCitation;
export {
  BlockQuote as default
};
